<div class="my-body">
    <h1 class="single-post-title">Paquetes disponibles</h1>
      <div class="cards" *ngIf="packages && packages.length>0">
        <div *ngFor="let pak of getPackagesByType()">
          
          <div [class]="getCssClass(pak)">
            <ul>
              <li class="pack">{{pak.name}}</li>
              <h2 class="price-box__discount">
                <span class="price-box__dollar">$</span>{{pak.price}}<span class="price-box__discount--light"></span>
              </h2>
              <h3 class="price-box__price">
                ${{getOldPrice(pak.price)}}
              </h3>
              <p *ngIf="pak.name != 'Basic'" style="font-size: 10px">* incluye los servcios del paquete anterior</p>
            </ul>
            <ul>
              <li *ngFor="let pro of pak.products" class="bottom-bar" >
                {{pro}}
              </li>
            </ul>
              <div style="padding: 1rem;">
                  <a *ngIf="pak.FK_ID_package_chosen != pak.id" href="/single/" (click)="goToPage('payments')" class="button button-fill button-round color-dark" style="padding: 10px 1rem;">Me interesa</a>
                  <!-- CONTRATADO -->
                  <a *ngIf="pak.FK_ID_package_chosen == pak.id" href="/single/" (click)="goToPage('payments')" class="paid button button-fill button-round">
                      <i class="fas fa-check" style="color: #FFFFFF;"></i>
                      Contratado
                  </a>
              </div>
              
          </div>
          
        </div>
      </div>
    </div>
    
    <div *ngIf="packages && packages.length ==0" class="center">
      <p>No hay ningún plan contratado en este momento.</p>
    </div>
    <mat-spinner *ngIf="!packages"></mat-spinner>
    
    <div class="parallax" *ngIf="false">
      <!-- carousel: midground parallax layer -->
      <div class="carousel" id="carousel">
        <mat-card *ngFor="let card of cards" class="carousel-cell"><!-- getPackagesByType() -->
          <span>DEV</span>
        </mat-card>
      </div>
    </div>
  